<script lang="ts" setup>
import moment from 'moment'
import jobCategory from '~/assets/data/job-category.json'
import locales from '~/assets/data/locales.json'
import dateLocale from '~/assets/data/date-localization.json'
import mkrbJobCategory from '~/public/assets/mkrb-category/title.json'

const { $config } = useNuxtApp()
const route = useRoute()
const jobTitleList = ref()
const category = route.params.cat

if (isEmpty(useGetSubdomain()))
  navigateTo('', { redirectCode: 301 })

const mkrbCategory = mkrbJobCategory.find(val => val.slug.toLowerCase() === category)
try {
  const response = await fetch(`/assets/mkrb-category/subtitle/${mkrbCategory.file}.json`)
  if (!response.ok)
    throw new Error('File not found')
  jobTitleList.value = (await response.json()).filter(item => item.en && item.en.trim() !== '')
  updateMeta()
}
catch (error) {
  console.error('Error fetching JSON:', error)
}

function updateMeta() {
  const country = locales.find(item => item.region === useGetSubdomain())?.label || ''
  const metaTitle = ref(`All ${useTextCapitalize(category.toString())} Jobs in ${country} | ${moment().format('MMMM')} ${moment().format('YYYY')} | Epicareer`)
  const metaDesc = ref(`Looking for all ${useTextCapitalize(category.toString())} jobs in ${country}? The companies here open hiring. Full-Time, Remote, Freelance, Part-Time, Internship Available on Epicareer!`)
  const robotsDefault = ($config.public.ENV === 'development' || $config.public.ENV === 'staging') ? { name: 'robots', content: 'nofollow, noindex' } : { name: 'robots', content: 'index, follow' }

  if (useGetSubdomain() === 'id') {
    const month = dateLocale[0]?.months[parseInt(moment().format('M')) - 1]
    metaTitle.value = `Semua Lowongan ${useTextCapitalize(category.toString())} di ${country} | ${month} ${moment().format('YYYY')} | Epicareer`
    metaDesc.value = `Cari semua pekerjaan ${useTextCapitalize(category.toString())} di ${country}? Perusahaan-perusahaan ini sedang hiring. Full-Time, Remote, Freelance, Part-Time, Internship Ada di Epicareer!`
  }
  else if (useGetSubdomain() === 'my') {
    const month = dateLocale[1]?.months[parseInt(moment().format('M')) - 1]
    metaTitle.value = `Semua Kerja Kosong ${useTextCapitalize(category.toString())} di ${country} | ${month} ${moment().format('YYYY')} | Epicareer`
    metaDesc.value = `Sedang mencari kerja ${useTextCapitalize(category.toString())} di ${country}? Syarikat-syarikat ini membuka peluang pekerjaan. Full-Time, Remote, Freelance, Part-Time, Internship semuanya ada di Epicareer!`
  }
  useHead({
    title: metaTitle,
    meta: [
      { property: 'og:title', content: metaTitle },
      { name: 'twitter:title', content: metaTitle },
      { name: 'description', content: metaDesc },
      { property: 'og:description', content: metaDesc },
      { name: 'twitter:description', content: metaDesc },
      robotsDefault,
    ],
    link: [
      { rel: 'canonical', href: useSetSubdomain(useGetSubdomain()) + route.path },
    ],
  })
}
</script>

<template>
  <BaseAtomsSkeletonBounded class="!py-0 !xl:px-0 text-gray-900">
    <!-- breadcrumb -->
    <nav class="flex py-6 md:pt-10 md:pb-5 text-xs max-w-lg" aria-label="Breadcrumb">
      <ol role="list" class="flex flex-nowrap items-center overflow-hidden">
        <li class="my-1.5">
          <div class="flex items-center">
            <NuxtLink to="/jobs" class="whitespace-nowrap flex items-center text-[#5843E5]">
              Jobs
              <Icon name="mdi:chevron-right" class="w-2.5 h-2.5 mx-1" />
            </NuxtLink>
          </div>
        </li>
        <li class="my-1.5">
          {{ category === 'it-engineer' ? 'IT Engineer' : useTextCapitalize(useTextToParam(category, true)) }}
        </li>
      </ol>
    </nav>

    <p class="text-4xl font-bold font-serif">
      {{ mkrbCategory.name }} Jobs
    </p>
    <div class="bg-[#F9FAFB] px-4 py-6 md:py-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 text-[#5843E5]">
      <div v-for="(item, idx) in jobTitleList" :key="idx">
        <NuxtLink :to="useGenerateSearchUrl(item.slug)" class="capitalize text-sm font-semibold cursor-pointer flex items-center">
          {{ item.name }}
        </NuxtLink>
        <NuxtLink :to="`/jobs/${category}/${item.slug}`" class="text-xs mt-1">
          Select city
        </NuxtLink>
      </div>
    </div>
  </BaseAtomsSkeletonBounded>
</template>
